import queryString from "query-string";

import { LEDGER_ACCOUNT } from "constants/actionTypes";

import { serializeLedgerAccount } from "lib/serializers/ledgerAccounts";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({ changesSince, id, action } = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/ledger-accounts/", id, action),
    query: {
      changesSince,
    },
  });

export const LedgerAccountAction = offlineActionCreator(
  LEDGER_ACCOUNT,
  serializeLedgerAccount,
  urlCreator,
  false,
);
